import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { PermissionsLoaderGuard } from '@core/guards/permissions-loader.guard';
import { HospitalsLoaderGuard } from '@core/guards/hospitals-loader.guard';
import { FirstLoginPasswordChangeGuard } from '@core/guards/first-login-password-change.guard';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: '',
        loadChildren: () => import('app/core/layouts/layout-login/layout-login.module').then(m => m.LayoutLoginModule),
    },
    {
        path: '',
        loadChildren: () => import('app/core/layouts/layout-main/layout-main.module').then(m => m.LayoutMainModule),
        canActivate: [AuthGuard, FirstLoginPasswordChangeGuard, PermissionsLoaderGuard, HospitalsLoaderGuard],
    },
    {
        path: 'impersonation',
        loadChildren: () => import('app/views/impersonation/impersonation.module').then(m => m.ImpersonationModule),
    },
    {
        path: 'book',
        loadChildren: () => import('app/views/book/book.module').then(m => m.BookModule),
        data: { title: 'app.entities.book', breadcrumb: 'app.entities.book' },
    },
    {
        path: '**',
        redirectTo: '404',
    },
];
